import * as React from 'react';
import * as ReactDOM from 'react-dom';

import { Route, Router } from 'react-router';

import AppRoot from "./root"

import { history } from './_helpers';

import { LocalizeProvider } from "react-localize-redux";
import './index.css';
import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(
	<LocalizeProvider>
		<Router history={history}>
			<Route path="/" component={AppRoot}></Route>
		</Router>
	</LocalizeProvider>,
	document.getElementById('root') as HTMLElement
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx